import { svgIconClasses } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { typographyClasses } from "@mui/material/Typography";

const SWA_BLUE = "#304cb2";
const SWA_RED = "#d5152e";

const theme = createTheme({
  palette: {
    primary: {
      light: "#6a77e5",
      main: SWA_BLUE,
      dark: "#002581",
      contrastText: "#fff",
      // SWA Primary Colors as per Digital Styleguide
      swaBlue: SWA_BLUE,
      swaYellow: "#ffbf27",
      swaRed: SWA_RED,
      swaDarkBlue: "#111b40",
    },
    secondary: {
      light: "#FFFFFF",
      main: "#FFFFFF",
      dark: "#FFFFFF",
      contrastText: "#fff",
      // SWA Secondary Colors as per Digital Styleguide
      swaOrange: "#ff792e",
      swaGreen: "#008020",
      swaTeal: "#0076a5",
      swaTurquoise: "#00A9E0",
      swaLightTurquoise: "#e2f8ff",
      swaLightYellow: "#ffeec2",
      swaLightRed: "#FECDD2",
      swaLightestBlue: "#e7eaf8",
      swaLightBlue: "#a4baf2",
      swaDarkBlue: "#1a2c80",
      swaBlue: "#294299",
      swaGray: "#636363",
      swaWhite: "#ffffff",
      swaGray1: "#f5f5f5",
      swaGray2: "#e6e7e8",
      swaGray3: "#cccccc",
      swaGray4: "#8f8f8f",
      swaGray5: "#3C3B3B",
      swaBlack: "#000000",
    },
    error: {
      main: SWA_RED,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1024,
      lg: 1280,
      xl: 1920,
    },
  },
  components: {
    // Reduce default font size to MUIv4 original size
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: "0.875rem",
          lineHeight: 1.43,
          letterSpacing: "0.01071em",
        },
      },
    },
    // Style our DatePicker's with SWA blue toolbar
    MuiDatePickerToolbar: {
      styleOverrides: {
        root: {
          color: "#fff",
          backgroundColor: SWA_BLUE,
          borderRadius: "3px 3px 0px 0px",
          [`& .${typographyClasses.root}`]: {
            color: "#fff",
          },
          [`& .${svgIconClasses.root}`]: {
            display: "none",
          },
        },
      },
    },
    MuiDateRangePickerToolbar: {
      styleOverrides: {
        root: {
          color: "#fff",
          backgroundColor: SWA_BLUE,
          borderRadius: "3px 3px 0px 0px",
          [`& .${typographyClasses.root}`]: {
            color: "#fff",
          },
          [`& .${svgIconClasses.root}`]: {
            display: "none",
          },
        },
      },
    },
  },
});

export default theme;
